/* eslint-disable react/destructuring-assignment */
import { Group } from '@mantine/core';
import { Relacao } from '../../../../../../business/events/general';
import DeleteConfirmPopover from '../../../../../../components/DeleteConfirmPopover';
import { EventRelationType } from '../../../../../../models/core/events.type';

type DataViewActionProps = {
  item: EventRelationType;
  confirmActionResult(items: EventRelationType[], type: Relacao, action: string, confirmed: boolean): void;
  // eslint-disable-next-line react/no-unused-prop-types
  zIndex: number;
};

export default function RelationFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      {props.item.codigoEventoRelacao === Relacao.Relacionado ? (
        <DeleteConfirmPopover
          label="Excluir"
          message="Esta ação removerá o contrato."
          variant="outline"
          onConfirm={() => {
            props.confirmActionResult([props.item], props.item.codigoEventoRelacao, 'excluir', true);
          }}
          onCancel={() => {
            props.confirmActionResult([props.item], props.item.codigoEventoRelacao, 'excluir', false);
          }}
        />
      ) : (
        '-'
      )}
    </Group>
  );
}
